// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-dfa67081] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.notecard[data-v-dfa67081] {
  --note-card-icon-size: 20px;
  --note-card-padding: calc(2 * var(--default-grid-baseline));
  color: var(--color-main-text) !important;
  background-color: var(--note-background) !important;
  border-inline-start: var(--default-grid-baseline) solid var(--note-theme);
  border-radius: var(--border-radius-small);
  margin: 1rem 0;
  padding: var(--note-card-padding);
  display: flex;
  flex-direction: row;
  gap: var(--note-card-padding);
}
.notecard__heading[data-v-dfa67081] {
  font-size: var(--note-card-icon-size);
  font-weight: 600;
}
.notecard__icon[data-v-dfa67081] {
  color: var(--note-theme);
}
.notecard__icon--heading[data-v-dfa67081] {
  font-size: var(--note-card-icon-size);
  margin-block: calc((1lh - 1em) / 2) auto;
}
.notecard--success[data-v-dfa67081] {
  --note-background: var(--color-success);
  --note-theme: var(--color-success-text);
}
.notecard--info[data-v-dfa67081] {
  --note-background: var(--color-info);
  --note-theme: var(--color-info-text);
}
.notecard--error[data-v-dfa67081] {
  --note-background: var(--color-error);
  --note-theme: var(--color-error-text);
}
.notecard--warning[data-v-dfa67081] {
  --note-background: var(--color-warning);
  --note-theme: var(--color-warning-text);
}
.notecard--legacy[data-v-dfa67081] {
  background-color: color-mix(in srgb, var(--note-background), var(--color-main-background) 80%) !important;
  color: var(--color-main-text) !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcNoteCard-l5nIN9Hg.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,2DAA2D;EAC3D,wCAAwC;EACxC,mDAAmD;EACnD,yEAAyE;EACzE,yCAAyC;EACzC,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;AACA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;AACA;EACE,yGAAyG;EACzG,wCAAwC;AAC1C","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-dfa67081] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.notecard[data-v-dfa67081] {\n  --note-card-icon-size: 20px;\n  --note-card-padding: calc(2 * var(--default-grid-baseline));\n  color: var(--color-main-text) !important;\n  background-color: var(--note-background) !important;\n  border-inline-start: var(--default-grid-baseline) solid var(--note-theme);\n  border-radius: var(--border-radius-small);\n  margin: 1rem 0;\n  padding: var(--note-card-padding);\n  display: flex;\n  flex-direction: row;\n  gap: var(--note-card-padding);\n}\n.notecard__heading[data-v-dfa67081] {\n  font-size: var(--note-card-icon-size);\n  font-weight: 600;\n}\n.notecard__icon[data-v-dfa67081] {\n  color: var(--note-theme);\n}\n.notecard__icon--heading[data-v-dfa67081] {\n  font-size: var(--note-card-icon-size);\n  margin-block: calc((1lh - 1em) / 2) auto;\n}\n.notecard--success[data-v-dfa67081] {\n  --note-background: var(--color-success);\n  --note-theme: var(--color-success-text);\n}\n.notecard--info[data-v-dfa67081] {\n  --note-background: var(--color-info);\n  --note-theme: var(--color-info-text);\n}\n.notecard--error[data-v-dfa67081] {\n  --note-background: var(--color-error);\n  --note-theme: var(--color-error-text);\n}\n.notecard--warning[data-v-dfa67081] {\n  --note-background: var(--color-warning);\n  --note-theme: var(--color-warning-text);\n}\n.notecard--legacy[data-v-dfa67081] {\n  background-color: color-mix(in srgb, var(--note-background), var(--color-main-background) 80%) !important;\n  color: var(--color-main-text) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
